<template>
	<div>

		<el-button size="mini" @click="initData(),showContractInfo = true">查看歷史合約</el-button>
		<el-button size="mini" class="btn-red" @click="showContractAdd=true">續約</el-button>




		<div class="module-contract-add" :class="showContractAdd?'show':''">
			<div class="title" style="margin-top: 0.1rem;">會員續約<span @click="showContractAdd=false"><i
						class="el-icon-close" style="font-size: 0.3rem;"></i></span></div>
			<div class="date-container">
				<!-- <div class="date-input-group">
					<label class="date-label">會員學校</label>
					<el-input class="input-date" v-model="post.value1" type="text" placeholder="">
					</el-input>
				</div>
				<div class="date-input-group">
					<label class="date-label">聯絡人姓名</label>
					<el-input class="input-date" v-model="post.value1" type="text" placeholder="">
					</el-input>
				</div>
				<div class="date-input-group">
					<label class="date-label">聯絡電話</label>
					<el-input class="input-date" v-model="post.value1" type="text" placeholder="">
					</el-input>
				</div> -->
				<div class="date-input-group">
					<label class="date-label">合約編號</label>
					<el-input class="input-date" v-model="post.contractNo" type="text" placeholder="">
					</el-input>
				</div>
				<div class="date-input-group">
					<label class="date-label">合約起始日期</label>
					<el-date-picker type="date" value-format="yyyy-MM-dd" class="input-date" clearable  v-model="post.startDate" placeholder="">
					</el-date-picker>
					
				</div>
				<div class="date-input-group">
					<label class="date-label">合約終止日期</label>
					<el-date-picker type="date" value-format="yyyy-MM-dd" class="input-date" clearable  v-model="post.endDate" placeholder="">
					</el-date-picker>
					
				</div>
				<div class="date-input-group">
					<label class="date-label">付款狀態</label>
					<el-select placeholder="" clearable  class="input-date" v-model="post.payStatus">
					
						<el-option label="未付款" value="0">
						</el-option>
						<el-option label="已付款" value="1">
						</el-option>
						<el-option label="已取消" value="2">
						</el-option>
					</el-select>
					
				</div>
				<div class="date-input-group">
					<label class="date-label">應收金額</label>
					<el-input class="input-date" v-model="post.payAmount" type="text" placeholder="">
					</el-input>
				</div>
				<div class="date-input-group">
					<label class="date-label">備註</label>
					<el-input class="input-date" v-model="post.remark" type="text" placeholder="">
					</el-input>
				</div>
			</div>
			<div class="dialog-footer" style="margin-top: 0.2rem;">
				<el-button size="" @click="showContractAdd = false">取 消</el-button>
				<el-button size="" type="primary" @click="sureAdd()">確定</el-button>
			</div>
		</div>

		<div class="module-contract-add" :class="showContractInfo?'show':''">
			<div class="title" style="margin-top: 0.1rem;">歷史合約<span @click="showContractInfo=false"><i
						class="el-icon-close" style="font-size: 0.3rem;"></i></span></div>
			<div class="contract-list">
				<div class="item" v-for="(item,index) in dataList" :key="index">
					<div class="item-date">記錄日期：{{item.createTime}}</div>
					<div class="item-content">
						<div class="item-show">
							合約編號<span>{{item.contractNo}}</span>
						</div>
						<div class="item-show">
							合約起始日期<span>{{item.startDate.split(' ')[0]}}</span>
						</div>
						<div class="item-show">
							合約終止日期<span>{{item.endDate.split(' ')[0]}}</span>
						</div>
						<div class="item-show">
							付款狀態<span>{{payStatusAttr[item.payStatus]}}</span>
						</div>
						<div class="item-show">
							合約狀態<span>{{statusAttr[item.status]}}</span>
						</div>
						
						<div class="item-show">
							合約金額<span>{{item.payAmount}}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="era-search u-flex" style="justify-content: center;margin-top: 0.2rem;">
				<el-pagination @current-change="currentChange" background layout="prev, pager, next" :total="dataTotal">
				</el-pagination>

			</div>
			<!-- <div class="dialog-footer" style="margin-top: 0.2rem;">
				<el-button size="" @click="showContractInfo = false">返回</el-button>
			</div> -->
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			userId: '',
		},
		data() {
			return {
				showContractAdd: false,
				showContractInfo: false,
				page: 1,
				schoolList: [],
				dataList: [],
				props: {
					multiple: true
				},
				roleList: [],
				deptList: [],
				propsDept: {
					// multiple: true,
					value: 'deptId',
					label: 'deptName',
				},
				// 付款状态（0：未付款；1：已付款；2：已取消）
				payStatusAttr:['未付款','已付款','已取消'],
				// 状态（0：待审核；1:已审核；2：已驳回）
				statusAttr:['待稽核','已稽核','已駁回'],
				
				postAdd: {
					archiveId: '',
					applyCount: '',
					applyContent: '',
				},
				post: {
					deptId: '',
					userName: '',
					nickName: '',
					email: '',
					password: '',
					status: 0,
					roleSort: '',
					selectRoleIds: '',
					remark: '',
				},
				accountInfo: {},
				roleDictList: [],
				dataTotal: 0,
				search: {
					pageSize: 10
				},
			}
		},
		created() {
			this.post.archiveId = this.userId
			this.postAdd.archiveId = this.userId

			this.initData()

		},
		methods: {
			getInfo() {

				this.$axios
					.post("rest-api/member/app/archive/detail", {
						id: this.post.archiveId
					})
					.then((res) => {
						this.accountInfo = res.data
					})
					.catch((err) => {});
			},
			sureGroupAdd() {

				this.$axios
					.post("rest-api/member/app/renewal/add", this.postAdd)
					.then((res) => {

						this.$message({
							message: '申請成功，請等待稽核',
							type: 'success'
						});
						this.showGroupAdd = false

					})
					.catch((err) => {});
			},
			getPercentage() {
				let num = 0
				if (this.accountInfo.totalCount) {
					num = (this.accountInfo.useCount / this.accountInfo.totalCount).toFixed(1) * 100
				}
				return num
			},
			toDel(idx) {

				this.$confirm('此操作將永久刪除該數據，是否繼續?', '提示', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					this.$axios
						.post("rest-api/member/app/renewal/delete", {
							id: this.dataList[idx].id
						})
						.then((res) => {
							this.$message({
								message: '刪除成功',
								type: 'success'
							});
							this.initData()
						})
						.catch((err) => {});
				}).catch(() => {
					// this.$message({
					//   type: 'info',
					//   message: '已取消删除'
					// });          
				});
			},

			sureAdd() {


				const that = this;
				let post = JSON.parse(JSON.stringify(that.post))
				
					that.$axios
						.post("rest-api/member/app/renewal/add", post)
						.then((res) => {
				
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.showContractAdd = false
							this.initData()
						})
						.catch((err) => {});

			},
			toEdit(item) {
				this.showUserAdd = true
				this.post = JSON.parse(JSON.stringify(item))
				this.post.permissions = item.permissionList
				this.post.status = Number(item.status)
			},
			toAdd() {
				this.post = {

					archiveId: '',
					name: '',
					post: '',
					email: '',
					password: '',
					status: 0,
					permissions: [],
					remark: '',
				}
				this.post.archiveId = this.userId
				this.post.password = this.generateRandomPassword()
				this.showUserAdd = true
			},
			currentChange(e) {

				this.page = e
				this.getList()
			},
			initData() {

				this.page = 1
				this.getList()
				this.getInfo()
			},
			getList() {

				const that = this;
				that.dataList=[]
				that.$axios
					.post("rest-api/member/app/renewal/page", {
						pageNum: that.page,
						pageSize: 5,
						archiveId: that.post.archiveId
					})
					.then((res) => {
						that.dataList = res.data.list
						that.dataTotal = res.data.total
					})
					.catch((err) => {});
			},
		}
	}
</script>

<style scoped lang="scss">
	.recruitment-dashboard {
		min-height: 100vh;
		background: #EEF3F6;
		padding: 0.2rem;
	}

	/* 頂部標題欄 */
	.dashboard-header {
		background: rgba(255, 255, 255, 0.95);
		border-radius: 0.12rem;
		padding: 0.2rem;
		margin-bottom: 0.2rem;
		box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.1);
	}

	.header-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.page-title {}

	.help-btn {
		background: #4a5568;
		color: white;
		border: none;
		padding: 0.08rem 0.2rem;
		border-radius: 0.06rem;
		font-size: 0.2rem;
		cursor: pointer;
	}

	/* 日期選擇區域 */
	.date-section {
		background: rgba(255, 255, 255, 0.95);
		border-radius: 0.12rem;
		padding: 0.2rem;
		margin-bottom: 0.2rem;
	}

	.date-container {
		display: flex;
		flex-wrap: wrap;
		// justify-content: space-between;
	}

	.date-input-group {
		width: 32%;
		min-width: 32%;
		margin-right: 1.2%;
		margin-bottom: 0.2rem;
	}

	.date-label {
		display: flex;
		align-items: center;
		margin-bottom: 0.08rem;
		color: #222;
		font-size: 0.18rem;
	}

	.date-input {
		background: #91A2A41A;
		border: 0.01rem solid #91A2A480;
		border-radius: 0.08rem;
		font-size: 0.2rem;
		padding: 0.12rem 0.1rem;
		color: #999;
	}

	/* 核心數據指標 */
	.kpi-section {
		flex: 1;
		margin-right: 0.1rem;
		background: rgba(255, 255, 255, 0.95);
		border-radius: 0.12rem;
		padding: 0.2rem;
	}

	.section-title {
		font-weight: bold;
		font-size: 0.2rem;
		margin-bottom: 0.2rem;
		color: #2d3748;
	}

	.kpi-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(1.8rem, 1fr));
		gap: 0.2rem;
	}

	.kpi-card {
		background: white;
		position: relative;
		border-radius: 0.12rem;
		padding: 0.25rem;
		box-shadow: 0.04rem 0.04rem 0.2rem 0rem #27545726;

		.ic-block {
			width: 0.5rem;
			height: 0.5rem;
			position: absolute;
			top: 0.25rem;
			right: 0.25rem
		}
	}

	.kpi-header {
		margin-bottom: 00.17rem;
	}

	.kpi-name {
		font-size: 0.18rem;
		color: #777;
	}

	.kpi-value {
		font-size: 0.32rem;
		color: #000;
		margin-bottom: 0.4rem;
	}

	.kpi-comparison {
		display: flex;
		align-items: center;
		gap: 0.06rem;
		font-size: 0.12rem;
	}

	.kpi-comparison.positive {
		color: #21C93A;
	}

	.trend-icon {
		font-weight: bold;
	}

	/* 主要內容區域 */
	.main-content {
		flex: 1;
		margin-left: 0.1rem;
		background: rgba(255, 255, 255, 0.95);
		border-radius: 0.12rem;
		padding: 0.2rem;
	}

	.content-grid {
		display: grid;
		grid-template-columns: 2fr 1fr;
		gap: 0.3rem;
	}

	/* 排行榜樣式 */
	.ranking-section {
		flex: 1;
		margin-left: 0.1rem;
		background: white;
		border-radius: 0.12rem;
		padding: 0.2rem;
		box-shadow: 0 0.02rem 0.1rem rgba(0, 0, 0, 0.05);
	}

	.ranking-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 0.1rem;
	}

	.ranking-title {
		font-size: 0.2rem;
		font-weight: bold;
		color: #2d3748;
		margin-bottom: 0.2rem;
	}

	.ranking-table {
		border: 0.01rem solid #27545726;
		border-radius: 0.1rem;
		margin-top: 0.2rem;
		overflow: hidden;
	}

	.ranking-date {
		color: #718096;
		font-size: 0.2rem;
	}

	.ranking-subtitle {
		color: #718096;
		font-size: 0.2rem;
		margin-bottom: 0.2rem;
	}

	.table-header {
		display: flex;
		padding: 0.12rem 0;
		border-bottom: 0.01rem solid #e2e8f0;
		background: #0BA29B0F;
		color: #4a5568;
		font-size: 0.18rem;
	}

	.table-header span {
		flex: 1;
		text-align: center;
	}

	.table-row span {
		flex: 1;
		word-break: break-all;
		text-align: center;
	}

	.table-row {
		display: flex;
		padding: 0.12rem 0;
		font-size: 0.18rem;
		border-bottom: 0.01rem solid #e2e8f0;
	}

	.rank {
		color: #4a5568;
	}

	.department {
		color: #2d3748;
	}

	.area,
	.rate {
		text-align: right;
		color: #4a5568;
	}

	/* 篩選區域樣式 */
	.filter-section {
		background: white;
		border-radius: 0.12rem;
		padding: 0.2rem;
		box-shadow: 0 0.02rem 0.1rem rgba(0, 0, 0, 0.05);
	}

	.filter-group {
		display: flex;
		gap: 0.1rem;
		margin-bottom: 0.2rem;
	}

	.filter-btn {
		flex: 1;
		padding: 0.1rem;
		border: 0.01rem solid #e2e8f0;
		background: #f7fafc;
		border-radius: 0.08rem;
		cursor: pointer;
		transition: all 0.3s;
	}

	.filter-btn.active {
		background: #667eea;
		color: white;
		border-color: #667eea;
	}

	.primary-btn {
		width: 100%;
		padding: 0.12rem;
		background: #667eea;
		color: white;
		border: none;
		border-radius: 0.08rem;
		font-size: 0.2rem;
		cursor: pointer;
		margin-bottom: 0.2rem;
	}

	.dropdown {
		width: 100%;
		padding: 0.12rem;
		border: 0.01rem solid #e2e8f0;
		border-radius: 0.08rem;
		background: white;
		margin-bottom: 0.2rem;
	}

	.stats-info {
		display: flex;
		flex-direction: column;
		gap: 0.12rem;
	}

	.stat-item {
		padding: 0.1rem;
		background: #f7fafc;
		border-radius: 0.06rem;
		text-align: center;
		color: #718096;
		font-size: 0.2rem;
	}

	/* 響應式設計 */
	@media (max-width: 1024px) {
		.content-grid {
			grid-template-columns: 1fr;
			gap: 0.2rem;
		}
	}

	@media (max-width: 768px) {
		.recruitment-dashboard {
			padding: 0.1rem;
		}

		.header-content {
			flex-direction: column;
			gap: 00.17rem;
			align-items: flex-start;
		}

		.date-container {
			flex-direction: column;
			gap: 00.17rem;
		}

		.kpi-grid {
			grid-template-columns: 1fr;
		}

		.table-header,
		.table-row {
			grid-template-columns: 0.5rem 1fr 0.8rem 0.7rem;
			gap: 0.1rem;
			font-size: 0.2rem;
		}

		.filter-group {
			flex-direction: column;
		}
	}

	@media (max-width: 480px) {
		.kpi-value {
			font-size: 0.24rem;
		}

		.table-header,
		.table-row {
			grid-template-columns: 0.4rem 1fr 0.7rem 0.6rem;
			gap: 0.08rem;
		}

		.ranking-header {
			flex-direction: column;
			align-items: flex-start;
			gap: 0.1rem;
		}
	}

	.search-title {
		font-weight: bold;
		display: flex;
		align-items: center;
		margin-bottom: 0.28rem;
	}

	.modle-block2 {
		display: flex;
	}

	@media (max-width: 1024px) {
		.modle-block2 {
			display: block;
		}

		.kpi-section {
			margin-right: 0;
		}

		.ranking-section {
			margin-left: 0;
		}
	}

	/* 页面标题 */
	.era-header {
		margin-bottom: 0.3rem;
	}

	.era-main-title {
		font-size: 0.28rem;
		font-weight: 700;
		color: #2d3748;
		text-align: center;
	}

	/* 内容网格布局 */
	.era-content-grid {
		display: grid;
		// grid-template-columns: 2fr 1fr;
		gap: 0.3rem;
		margin: 0 auto;
	}

	/* 排行榜区域 */
	.era-ranking-section {}

	.era-section-header {
		margin: 0 0 0.2rem;
	}

	.era-section-title {
		font-weight: bold;
		color: #2d3748;
		justify-content: space-between;

		.title-btn {
			background: #0BA29B;
			padding: 0.12rem;
			border-radius: 0.06rem;
			color: #fff;
			cursor: pointer;
			font-size: 0.2rem;
		}

		.tips {
			font-weight: normal;
			font-size: 0.12rem;
			color: #ED6D00;
			margin-left: 0.3rem;
		}

		img {
			width: 0.2rem;
			height: 0.2rem;
			margin-right: 0.06rem;
		}
	}

	.era-section-title-sub {
		font-size: 00.17rem;
		font-weight: bold;
		color: #0BA29B;
		margin-bottom: 0.2rem;
		margin-top: 0.2rem;
	}

	/* 表格样式 */
	.era-table-container {
		overflow-x: auto;
	}

	.era-ranking-table {
		width: 100%;
		border-collapse: collapse;
		font-size: 0.2rem;
	}

	.era-ranking-table th {
		background: #f8fafc;
		padding: 0.12rem 0.08rem;
		text-align: left;
		font-weight: bold;
		color: #4a5568;
		border-bottom: 0.02rem solid #e2e8f0;
	}

	.era-ranking-table td {
		padding: 0.12rem 0.08rem;
		border-bottom: 0.01rem solid #e2e8f0;
		color: #4a5568;
	}

	.era-ranking-table .era-highlight-row {
		background: #fffaf0;
	}

	.era-ranking-table .era-highlight-row td {
		font-weight: 500;
	}

	.era-rank-col {
		width: 0.6rem;
	}

	.era-name-col {
		min-width: 2rem;
	}

	.era-private-col {
		width: 1.2rem;
	}

	.era-growth-col {
		width: 1rem;
	}

	.era-school-col {
		width: 1.4rem;
	}

	.era-rank-cell {
		text-align: center;
	}

	.era-rank-number {
		display: inline-block;
		width: 0.28rem;
		height: 0.28rem;
		line-height: 0.28rem;
		text-align: center;
		background: #667eea;
		color: white;
		border-radius: 50%;
		font-size: 0.12rem;
		font-weight: bold;
	}

	.era-ranking-table .era-highlight-row .era-rank-number {
		background: #ed8936;
	}

	.era-name-cell {
		color: #2d3748;
		font-weight: 500;
	}

	.era-growth-cell {
		text-align: center;
	}

	.era-growth-rate.era-positive {
		color: #48bb78;
		font-weight: bold;
	}

	.era-school-cell {
		text-align: right;
	}

	/* 右侧数据面板 */
	.era-stats-panel {
		display: flex;
		flex-direction: column;
		gap: 0.25rem;
		padding-top: 0.4rem;
	}

	.era-chart-section,
	.era-quality-section {
		background: #EEF6F685;
		border-radius: 00.17rem;
		padding: 0 00.17rem 00.17rem;
	}

	.era-chart-title {
		font-size: 0.2rem;
		font-weight: bold;
		color: #2d3748;
		margin-bottom: 0.2rem;
	}

	/* 管道列表 */
	.era-channel-list {
		display: flex;
		flex-direction: column;
		gap: 0.12rem;
	}

	.era-channel-item {
		display: flex;
		align-items: center;
		gap: 0.1rem;
		padding: 0.08rem 0;
	}

	.era-channel-dot {
		width: 0.12rem;
		height: 0.12rem;
		border-radius: 50%;
	}

	.era-channel-dot.era-organic {
		background: #48bb78;
	}

	.era-channel-dot.era-referral {
		background: #ed8936;
	}

	.era-channel-dot.era-social {
		background: #9f7aea;
	}

	.era-channel-dot.era-paid {
		background: #4299e1;
	}

	.era-channel-dot.era-direct {
		background: #f56565;
	}

	.era-channel-name {
		color: #4a5568;
		font-size: 0.2rem;
	}

	/* 品质评比表格 */
	.era-quality-table {
		display: flex;
		flex-direction: column;
		gap: 00.17rem;
	}

	.era-table-header {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		gap: 00.17rem;
		padding-bottom: 0.1rem;
		border-bottom: 0.02rem solid #e2e8f0;
		font-weight: bold;
		color: #4a5568;
		font-size: 0.12rem;
	}

	.era-table-body {
		display: flex;
		flex-direction: column;
		gap: 0.12rem;
	}

	.era-table-row {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		gap: 00.17rem;
		align-items: center;
	}

	.era-channel-cell {
		font-size: 0.12rem;
		color: #4a5568;
		font-weight: 500;
	}

	.era-progress-cell {
		position: relative;
	}

	.era-progress-bar {
		position: relative;
		height: 0.24rem;
		background: #f7fafc;
		border-radius: 0.12rem;
		overflow: hidden;
	}

	.era-progress-fill {
		height: 100%;
		background: linear-gradient(90deg, #667eea, #764ba2);
		border-radius: 0.12rem;
		transition: width 0.3s ease;
	}

	.era-progress-fill.era-depth-fill {
		background: linear-gradient(90deg, #48bb78, #38a169);
	}

	.era-progress-text {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-size: 0.11rem;
		font-weight: bold;
		color: #2d3748;
		z-index: 1;
	}

	/* 响应式设计 */
	@media (max-width: 1200px) {
		.era-content-grid {
			grid-template-columns: 1fr;
			gap: 0.2rem;
		}

		.era-stats-panel {
			flex-direction: row;
		}

		.era-stats-panel {
			padding-top: 0;
		}

		.era-chart-section,
		.era-quality-section {
			flex: 1;
		}

		.page-title {
			display: block;

			.page-title-btn {
				cursor: pointer;
				display: flex;
				justify-content: space-between;
			}
		}
	}

	@media (max-width: 768px) {

		.date-input-group {
			width: 100%;
			min-width: 100%;
			margin: 0;
		}

		.dialog-account {
			width: 90% !important;
		}

		.era-container {
			padding: 00.17rem;
		}

		.era-section-title {

			.tips {
				margin-left: 0;
				margin-top: 00.17rem;
			}
		}

		.era-main-title {
			font-size: 0.22rem;
		}

		.era-content-grid {
			gap: 00.17rem;
		}

		.era-stats-panel {
			flex-direction: column;
		}

		.era-ranking-table {
			font-size: 0.12rem;
		}

		.era-ranking-table th,
		.era-ranking-table td {
			padding: 0.08rem 0.06rem;
		}

		.era-name-col {
			min-width: 1.5rem;
		}

		.era-private-col {
			width: 1rem;
		}

		.era-growth-col {
			width: 0.8rem;
		}

		.era-school-col {
			width: 1.2rem;
		}
	}

	@media (max-width: 480px) {
		.era-container {
			padding: 0.1rem;
		}

		.era-main-title {
			font-size: 0.2rem;
		}

		.era-ranking-table {
			font-size: 0.11rem;
		}

		.era-ranking-table th,
		.era-ranking-table td {
			padding: 0.06rem 0.04rem;
		}

		.era-table-header,
		.era-table-row {
			grid-template-columns: 1fr 1fr;
			gap: 0.1rem;
		}

		.era-table-header .era-depth-header,
		.era-table-row .era-progress-cell:last-child {
			display: none;
		}

		.era-rank-number {
			width: 0.24rem;
			height: 0.24rem;
			line-height: 0.24rem;
			font-size: 0.11rem;
		}
	}

	.era-content-grid {
		margin-top: 0.2rem;
		background: white;
		border-radius: 0.12rem;
		padding: 0.2rem;
		box-shadow: 0 0.04rem 0.2rem rgba(0, 0, 0, 0.08);
	}

	.page-title {
		justify-content: space-between;
		margin: 0 0 0.3rem;

		.page-title-main {
			font-size: 0.26rem;
			font-weight: bold;
		}

		.page-title-sub {
			color: #0BA29B;
			font-size: 0.22rem;
			font-weight: bold;
			margin-top: 0.12rem;
		}
	}

	.module-show {
		background: #ED6D001A;
		color: #ED6D00;
		font: size 0.2rem;
		padding: 0.2rem;
		margin-top: 0.3rem
	}

	.tips1 {
		background: #ED6D001A;
		border-radius: 16px;
		font-size: 0.12rem;
		color: #ED6D00;
		padding: 0.08rem 0.2rem;

	}

	.item-btn {
		display: flex;
		justify-content: center;

		.btn {
			cursor: pointer;
			padding: 0 0.05rem;
		}

		.btn-edit {
			color: #0BA29B
		}

		.btn-del {
			color: #FF383C
		}
	}

	.module-count {
		background: #F3F3F3;
		border: 1px dashed #275457;
		border-radius: 10px;
		padding: 0.3rem 0.24rem;

		.module-header {
			justify-content: space-between;
			font-weight: bold;
			margin-bottom: 0.2rem;
		}
	}

	.btn-add {

		background: #0BA29B;
		padding: 0.12rem;
		border-radius: 0.06rem;
		color: #fff;
		font-size: 0.2rem;
		margin-top: 0.2rem;
	}

	.input-tips {
		font-size: 0.12rem;
		color: #999;
	}

	.title {
		font-size: 0.2rem;
		color: #222;
		margin-top: 0.24rem;
		margin-bottom: 0.24rem;
		display: flex;
		justify-content: space-between;
	}

	.dialog-account {
		width: 8rem;
		margin: 0 auto;

		::v-deep .el-dialog {
			width: 100% !important;
			overflow: auto
		}
	}

	.module-role {
		border-top: 1px dashed #E1E1E1;
		padding-top: 0.3rem;
		margin-top: 0.3rem;
	}

	.module-contract-add {

		position: fixed;
		top: 0;
		right: -100%;
		opacity: 0;
		transition: 0.5s ease-in-out;
		width: 30%;
		z-index: 100;
		bottom: 0;
		display: block;
		background-color: #F7F8FC;
		padding: 0.2rem;
		height: 100%;
		overflow: auto;
		box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.2);
	}

	.module-contract-add .date-input-group {

		width: 100%;
		min-width: 100%;
		margin: 0 0 0.2rem;
	}

	.module-contract-add.show {

		opacity: 1;
		right: 0
	}

	.contract-list {
		.item {
			margin-bottom: 0.24rem;
		}

		.item-date {
			font-size: 0.14rem;
			font-weight: bold;
		}

		.item-content {

			border: 1px solid #949BAA4D;
			border-radius: 5px;
			padding: 0.06rem 0.12rem;
			margin-top: 0.1rem;
		}

		.item-show {
			font-size: 0.14rem;
			display: flex;
			justify-content: space-between;
			padding: 0.06rem;

		}
	}

	@media (max-width: 1024px) {
		.module-contract-add {
			width: 90%;

		}

		.module-contract-add .date-input-group {

			margin: 0;
		}
	}
</style>